import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IUserData, IUserState } from 'store/user/types';
import { getSelectedClient as getSelectedClientFromStorage } from 'services/storage';

export const getUserState = (state: RootState): IUserState => state.user;

export const getUserData = createSelector(
  [getUserState],
  (state: IUserState): IUserData => state.data
);

export const getUserClientId = createSelector(
  [getUserState],
  // Fall back to localStorage so a refresh keeps the selected client before Redux rehydrates.
  // setSelectedClient is always paired with a setUserClientID dispatch, so localStorage only ever
  // changes alongside state.user — the storage read below stays in sync while running once per
  // user-state change instead of on every dispatch.
  ({ clientID }: IUserState): number | null =>
    clientID ?? getSelectedClientFromStorage()?.id ?? null
);
